import type { ReactNode } from 'react'

import { Icon, type IconName } from 'components/Icon'

import * as S from '../styles'

type MenuItemContentProps = {
  icon?: IconName
  children: ReactNode
  collapsed: boolean
}

export const MenuItemContent = ({ icon, children, collapsed }: MenuItemContentProps) => {
  const shouldShowContent = !icon || !collapsed

  return (
    <S.Flex alignItems="center" gap="sm" justifyContent="space-between">
      {icon && <Icon icon={icon} size="24" />}

      {shouldShowContent && (typeof children === 'string' ? <S.Text>{children}</S.Text> : children)}
    </S.Flex>
  )
}
